/* @jest-environment jsdom */

import { createSelector } from 'reselect';
import { initialState } from './reducer';
import {
    AVAILABLE_TARIFFS,
    AVAILABLE_TARIFFS_02,
    UI_STATE,
} from './constants';
import { RoamingOption } from './types';

const selectState = state => state.ROAMING_ADVISOR || initialState;

const selectLoading = () =>
    createSelector(
        selectState,
        state => state.loading,
    );

const selectCountries = () =>
    createSelector(
        selectState,
        state => state.countries,
    );

const selectRoamingOptions = () =>
    createSelector(
        selectState,
        state => state.roamingOptions,
    );

const selectError = () =>
    createSelector(
        selectState,
        state => state.error,
    );

const selectSelectedCountry = () =>
    createSelector(
        selectState,
        state => state.selectedCountry,
    );

const selectSelectedDestination = () =>
    createSelector(
        selectState,
        state => state.selectedDestination,
    );

const selectAvailibleTariffs = () =>
    createSelector(
        selectState,
        state => {
            if (state.selectedDestination === 'inForeignCountrySmartDevice') {
                return AVAILABLE_TARIFFS_02;
            }

            return AVAILABLE_TARIFFS;
        },
    );

const selectUiState = () =>
    createSelector(
        selectState,
        state => {
            if (!state.selectedDestination) {
                return UI_STATE.SELECT_DESTINATION;
            }

            if (state.noRoamingForSelectedCountry) {
                return UI_STATE.NO_ROAMING_FOR_SELECTION;
            }

            if (state.selectedDestination && !state.selectedCountry && !state.roamingOptions) {
                return UI_STATE.SELECT_COUNTRY;
            }

            if (state.selectedDestination && state.selectedCountry && !state.selectedTariff && !state.roamingOptions) {
                return UI_STATE.SELECT_TARIFF;
            }

            if (state.selectedDestination && state.selectedCountry && state.selectedTariff && !state.roamingOptions) {
                return UI_STATE.TARIFF_SELECTED;
            }

            if (state.roamingOptions) {
                return UI_STATE.DISPLAY_OPTIONS;
            }
        },
    );

const countriesSelector = countries => {
    const suggesComponentCountries = [];
    countries.forEach(element => {
        const imgIconSrc = `https://media.vodafone.de/www/images/app/${element.countryCode.toLowerCase()}_flag.png`;
        suggesComponentCountries.push({
            text: element.name,
            imgIconSrc,
        });
    });

    return suggesComponentCountries;
};

const roamingOptionVOs = options => {
    const optionVOs = [];

    options.forEach(element => {
        const txtCopy = element.txtCopy;

        const description = txtCopy.split('<span class="h4b">')[0].replace('<p>', '').replace('<p/>', '').replace('<br /><br />', '');

        const priceString = txtCopy.split('<span class="h4b">')[1]?.split('</span>')[0];
        const bookingOptionText = txtCopy.split('</span>')[1]?.replace('<br />', '');

        const ro: RoamingOption = {
            title: element.stdHeadline,
            description,
            link: `${element.linkPrimaryCta}`,
            bookingOptionText: (bookingOptionText && bookingOptionText.length > 0) && bookingOptionText,
        };

        // price

        if (priceString && priceString.length > 0) {
            const promoPrice = {
                priceCondition: undefined,
                additionalText: priceString.split('Euro')[1],
                price: {
                    euro: parseInt(priceString.split(',')[0], 10),
                    cent: parseInt(priceString.split(',')[1], 10),
                },
            };
            ro.promoPrice = promoPrice;
        }

        optionVOs.push(ro);
    });

    return optionVOs;
};

export {
    selectLoading,
    selectCountries,
    countriesSelector,
    selectUiState,
    selectRoamingOptions,
    selectError,
    selectSelectedCountry,
    selectSelectedDestination,
    selectAvailibleTariffs,
    roamingOptionVOs,
};
